import { Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'
import {
    MenuIcon,
    XIcon,
    CheckIcon,
    SparklesIcon,
    ChatAltIcon,
    DocumentReportIcon,
    HeartIcon,
    CurrencyDollarIcon,
    InboxIcon,
    PencilAltIcon,
    ReplyIcon,
    CalendarIcon,
    ExternalLinkIcon,
    DatabaseIcon,
    DocumentIcon,
    ViewGridAddIcon,
    UsersIcon,
} from '@heroicons/react/outline'
import { BadgeCheckIcon, ChevronRightIcon } from '@heroicons/react/solid'
import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react'
import dynamic from 'next/dynamic'
import { cloudfront } from "../../config";
import bizStyles from '../../styles/Business.module.css'
import Layout from '../../components/Layouts/homeLayout'
import AlertTemplate from '../../components/Notification'
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import { useAuth, AuthProvider } from '../../contexts/Auth'
import Calendar from '../../components/Gthr/Scheduler/Utils/Calendar'
import { supabase } from '../../utils/supabaseClient'
import Meta from "../../components/Meta"
const Demo = dynamic(() => import('../../components/Demos/Demo'), {
    ssr: false
})


const navigation = [
    // { name: 'Product', href: '#' },
    // { name: 'Features', href: '#' },
    // { name: 'Marketplace', href: '#' },
    // { name: 'Company', href: '#' },
]

const tiers = [
    {
        name: 'Hobby',
        href: '#',
        priceMonthly: 0,
        description: 'All the basics for starting a new business',
        includedFeatures: ['Customizable video templates', 'Create up to five rooms a month', '1-on-1 meetings'],
    },
    {
        name: 'Freelancer',
        href: '#',
        priceMonthly: 12,
        description: 'All the basics for starting a new business',
        includedFeatures: [
            'Create a booking page',
            'Set available hours or create events',
            '1-on-1 and group meetings',
            'Live support for new features',
        ],
    },
    {
        name: 'Startup',
        href: '#',
        priceMonthly: 24,
        description: 'All the basics for starting a new business',
        includedFeatures: [
            'Includes all freelancer tools',
            'Up to 5,000 minutes',  //figure this out correctly
            'Custom CRM and Calendly Integrations',
            'Priority live support for new features',
        ],
    },
    {
        name: 'Pay-per-meeting',
        href: '#',
        priceMonthly: "--",
        description: 'Do you need more booked meetings for your business?',
        includedFeatures: [
            "We'll get you booked meetings for a fixed price",
            'Great for agencies',
            'Only pay for real face-to-face meetings',
        ],
    },
]

const features = [
    {
        name: 'Accept Payments',
        description: 'Add a payment gateway to book meetings',
        icon: CurrencyDollarIcon,
    },
    {
        name: 'Create a Booking Page',
        description: 'Use a landing page for clients to book meetings and receive inquiries',
        icon: DocumentIcon,
    },
    {
        name: 'Schedule recurring or one-time events',
        description: 'Setup recurring or one-time events',
        icon: CalendarIcon,
    },
    {
        name: 'CRM Integrations',
        description: "Let us know what type of integration you need and we'll help you out",
        icon: DatabaseIcon,
    },
    {
        name: 'Post to Notion',
        description: 'Automatically create a page in notion with your meeting notes for future reference',
        icon: ExternalLinkIcon,
    },
    {
        name: 'Custom Template',
        description: "Do you have a mockup or idea for a new template? Let's build it!",
        icon: PencilAltIcon,
    },
    {
        name: 'Calculator Editor',
        description: 'Use a collaborative calculator to provide custom quotes or show how much clients could save with your product/service',
        icon: ViewGridAddIcon,
    },
    {
        name: 'Add Triggers',
        description: 'Setup custom triggers to automatically send a user a follow-up email, giftcard, or plant a tree  ',
        icon: ChatAltIcon,
    },

]

export default function Network() {
    let tz = Intl.DateTimeFormat().resolvedOptions().timeZone ? Intl.DateTimeFormat().resolvedOptions().timeZone : "America/Los_Angeles"
    const [stopCode, setStopCode] = useState(true)
    const [subPage, setSubPage] = useState(0)
    const [submitted, setSubmitted] = useState(false)
    const [loading, setLoading] = useState(false)
    const [meeting, setMeeting] = useState({
        "name": "", "person": "", "email": "", "notes": "", "dateStr": null, "student_profile": null,
        "appointment_datetime": null, "timezone": tz, "meeting_dates": []
    })
    const { user, signOut } = useAuth()

    const handleChange = (e) => {
        let newMeeting = { ...meeting }
        if (e.target) {
            newMeeting[e.target.name] = e.target.value
            setMeeting(newMeeting)
        }
    }

    const handleTimeChange = (newValue) => {
        let newMeeting = { ...meeting }
        newMeeting.timezone = newValue.value
        setMeeting(newMeeting)
    }

    const handleDateStr = (dateTime) => {
        let newMeeting = { ...meeting }
        newMeeting["dateStr"] = dateTime.toFormat('DD')
        newMeeting["appointment_datetime"] = dateTime.toISO()
        setMeeting(newMeeting)
    }

    const requestAccount = async (e) => {
        setLoading(true)
        e.preventDefault()

        const { data, error } = await supabase
            .from("main_request_access")
            .insert({ email: meeting.email, type: "network" })

        error && console.log(error)

        !error && setSubmitted(true)
        //might want to send email
    }




    return (
        <div className="relative overflow-hidden">
            <Meta
                title="Plaza Advertising Network"
                description="The Plaza advertising network connects virtual coaches and consultants to thrid-party publishers to help coaches receive new leads and clients"

            />

            <main>
                <section className="pt-10 bg-slate-200/50 -mt-0 sm:pt-10 lg:pt-0 lg:pb-14 lg:overflow-hidden mb-2 sm:mb-40 md:mb-40 lg:mb-0">
                    <div className="mx-auto max-w-7xl lg:px-8">
                        <div className="lg:grid lg:grid-cols-2 lg:gap-8">
                            <div className="mx-auto h-full max-w-md px-4 sm:max-w-2xl sm:px-6 sm:text-center lg:px-0 lg:text-left lg:flex lg:items-center">
                                <div className="lg:py-24">
                                    {/* <a
                      href="#"
                      className="inline-flex items-center text-white bg-black rounded-full p-1 pr-2 sm:text-base lg:text-sm xl:text-base hover:text-gray-200"
                    >
                      <span className="px-3 py-0.5 text-white text-xs font-semibold leading-5 uppercase tracking-wide bg-fuchsia-700 rounded-full">
                        Beta
                      </span>
                      <span className="ml-4 text-sm">We just launched!</span>
                      <ChevronRightIcon className="ml-2 w-5 h-5 text-gray-600" aria-hidden="true" />
                    </a> */}     <div className='mt-1'><span className='text-fuchsia-700 bg-fuchsia-100 px-2 py-1 rounded-lg'>Coming Soon</span></div>
                                    <h1 className="mt-4 text-5xl tracking-tight font-extrabold mb-10 text-black sm:mt-5 sm:text-6xl lg:mt-2 xl:text-5xl">
                                        <span className="block ">The <span className="text-fuchsia-600">first</span> advertising</span>
                                        <span className="block "> network for <span className="underline decoration-fuchsia-600 decoration-wavy decoration-4">virtual coaches</span></span>
                                    </h1>
                                    <div className="blur-3xl  -ml-10  absolute h-32 w-32 -z-10 bg-fuchsia-500" />

                                    <p className="mt-3 text-base text-gray-700 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                                        As a virtual coach/consultant, let us get you fresh leads to sustain your business with our network of third-party publishers

                                    </p>
                                    <div className="mt-10 sm:mt-12">
                                        {!submitted ?
                                            <form action="#" className="sm:max-w-xl sm:mx-auto lg:mx-0">
                                                <div className="sm:flex">
                                                    <div className="min-w-0 flex-1">
                                                        <label htmlFor="email" className="sr-only">
                                                            Email address
                                                        </label>
                                                        <input
                                                            name="email"
                                                            defaultValue={meeting.email}
                                                            onChange={handleChange}
                                                            placeholder="Enter your email"
                                                            className="block w-full px-4 py-3 rounded-md border-0 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-300 focus:ring-offset-gray-900"
                                                        />
                                                    </div>
                                                    <div className="mt-3 sm:mt-0 sm:ml-3">
                                                        <button
                                                            onClick={requestAccount}
                                                            className="block w-full py-3 px-4 rounded-md hover:text-gray-900 shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700 text-white font-medium hover:bg-fuchsia-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 focus:ring-offset-gray-900"
                                                        >
                                                            {loading ? <div className="flex justify-center">
                                                                <svg className="animate-spin h-5 w-5 my-auto text-zinc-900 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                                </svg>
                                                            </div> : "Request Account"}
                                                        </button>
                                                    </div>
                                                </div>
                                                <p className="mt-3 text-sm text-gray-600 sm:mt-4">
                                                    {/* Start your free 14-day trial, no credit card necessary.*/} By providing your email, you agree to
                                                    our{' '}
                                                    <Link href="/terms-conditions">
                                                        <a className="font-medium text-gray-900">
                                                            terms of service
                                                        </a>
                                                    </Link>
                                                    .
                                                </p>
                                            </form>
                                            :
                                            submitted &&
                                            <div className="flex items-center justify-center lg:justify-start lg:mx-0">
                                                <BadgeCheckIcon className="text-green-600 h-7 w-7 mr-3" /> <div>Email submitted.  We&apos;ll follow-up within 24 hours.</div>
                                            </div>
                                        }

                                    </div>
                                </div>
                            </div>
                            <div className=" lg:pt-20 -mb-16 sm:-mb-48 lg:m-0 lg:relative">

                                <div className="blur-3xl mt-20 -ml-10 right-0 absolute h-32 w-32 -z-10 bg-fuchsia-500" />
                                <div className='my-auto'>
                                    <div className='bg-white border-2 p-5 rounded-lg w-full '>
                                        <h2 className='font-extrabold text-xl text-slate-700  '>Available Nutritionists</h2>
                                        <div className='space-x-6 flex mt-3'>
                                            <div className='w-1/3'>
                                                <Image
                                                    className='rounded-full'
                                                    width="500"
                                                    height="250"
                                                    src="https://d28zq0um2frnpx.cloudfront.net/static/women2_waive.jpg"
                                                    objectFit='cover'
                                                    alt="plaza icon"
                                                />
                                                <h2 className='font-extrabold text-slate-800 '>Jessica Peters</h2>
                                                <div className='text-slate-500 text-sm min-h-[100px]'>
                                                    Tired of the endless diet schedule?  Diets don&apos;t work for everyone, I can help setup your own personal plan
                                                </div>

                                                <button
                                                    className="w-full mt-2  shadow-lg shadow-slate-400/50 py-1 border border-transparent text-base font-medium rounded-md text-white bg-slate-500 hover:bg-slate-900"
                                                >
                                                    Book
                                                </button>

                                            </div>

                                            <div className='w-1/3'>
                                                <Image
                                                    className='rounded-full'
                                                    width="500"
                                                    height="250"
                                                    src="https://d28zq0um2frnpx.cloudfront.net/static/woman_1_home.jpg"
                                                    objectFit='cover'
                                                    alt="plaza icon"
                                                />
                                                <h2 className='font-extrabold text-slate-800 '>Sarah Thomas</h2>
                                                <div className='text-slate-500 text-sm min-h-[100px]'>
                                                    Looking for a sports nutritionists to help you acheive your athletic goals?
                                                </div>
                                                <button
                                                    className="w-full  mt-2  shadow-lg shadow-slate-400/50 py-1 border border-transparent text-base font-medium rounded-md text-white bg-slate-500 hover:bg-slate-900"
                                                >
                                                    Book
                                                </button>

                                            </div>

                                            <div className='w-1/3'>
                                                <Image
                                                    className='rounded-full'
                                                    width="500"
                                                    height="250"
                                                    src="https://d28zq0um2frnpx.cloudfront.net/static/man1-waive.jpg"
                                                    objectFit='cover'
                                                    alt="plaza icon"
                                                />
                                                <h2 className='font-extrabold text-slate-800 '>John Lawrence</h2>
                                                <div className='text-slate-500 text-sm min-h-[100px]'>
                                                    If you&apos;re seeking freedom from your eating disorder, I help breakdown the importantance of restoring your balanace
                                                </div>
                                                <button
                                                    className="w-full shadow-lg mt-2 shadow-slate-400/50 py-1 border border-transparent text-base font-medium rounded-md text-white bg-slate-500 hover:bg-slate-900"
                                                >
                                                    Book
                                                </button>

                                            </div>
                                        </div>


                                        <p className='mt-5 flex items-center justify-end space-x-4'>
                                            <span className='text-slate-500 mr-2 text-sm'>Powered by</span> <Image
                                                width="20"
                                                height="20"
                                                src="https://d28zq0um2frnpx.cloudfront.net/static/plaza-tail-transparent.png"
                                                objectFit='cover'
                                                alt="plaza icon"
                                            /></p>


                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                {/* More main page content here... */}
                <section className="relative bg-white pt-16 pb-32 overflow-hidden">
                    <div className="">
                        <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
                            <div className="px-4 max-w-xl mx-auto sm:px-6 lg:py-32 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-2">
                                <div>
                                    <div className='z-20 relative'>
                                        <span className="h-12 w-12 rounded-md flex items-center justify-center bg-fuchsia-700">
                                            <CalendarIcon className="h-6 w-6 text-white" aria-hidden="true" />
                                        </span>
                                    </div>
                                    <div className="mt-6 z-20 relative">
                                        <h2 className="text-3xl font-extrabold tracking-tight text-gray-900">
                                            For virtual coaches/consultants
                                        </h2>
                                        <p className="mt-4 text-lg text-gray-500">
                                            Are you looking for more customers at an affordable acquisition cost?  Book a demo to discuss
                                            how we can help you generate more clients.  Options include leads delivered to your inbox or 
                                            booked discovery calls
                                        </p>
                                        <div className="mt-6">
                                            <a
                                                href="#bookDemo"
                                                className="inline-flex px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-fuchsia-700 hover:bg-fuchsia-900"
                                            >
                                                Book a Demo
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-12 sm:mt-16 lg:mt-0 lg:col-start-1 flex items-center  ">
                                <div className="pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 my-auto img-cont z-10" >
                                    <Image
                                        className={bizStyles.editorMockup + " scale-125"}
                                        src={`${cloudfront}/static/coach_directory_mock.png`}
                                        width={1920}
                                        height={1180}
                                        objectFit={"cover"}
                                        alt="Plaza for video consultations"

                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="relative mt-24">
                        <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
                            <div className="px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
                                <div>
                                    <div>
                                        <span className="h-12 w-12 rounded-md flex items-center justify-center bg-fuchsia-700">
                                            <PencilAltIcon className="h-6 w-6 text-white" aria-hidden="true" />
                                        </span>
                                    </div>
                                    <div className="mt-6 mr-10">
                                        {/* <h2 className="text-3xl font-extrabold tracking-tight text-gray-900">
                            Better understand your customers
                        </h2> */}
                                        <h2 className="text-3xl font-extrabold tracking-tight text-gray-900">
                                            For Websites, Publishers, and Influencers
                                        </h2>
                                        <p className="mt-4 text-lg text-gray-500 relative z-20">Try a brand new way of monetizing your site!  Copy + paste your unique Plaza script into your website
                                        and start generating revenue for each lead or meeting you generate.  Plaza&apos;s unqiue embeddable script allows visitors to book a discovery call or submit their information
                                        {' '}<span className="underline decoration-fuchsia-600 decoration-dotted decoration-4">without leaving your site </span>
                                        </p>
                                        {/* <p className="mt-4 text-lg text-gray-500">
                            Customer feedback is crucial when growing your startup.  Most will send a quick survey, 
                            but if you actually want to get to know your customers in a 1-on-1 conversation, try a 
                            Plaza meeting to generate better insights
                        </p> */}
                                        <div className="mt-6">
                                            <a
                                                href="#"
                                                className="inline-flex px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-fuchsia-700 hover:bg-indigo-700"
                                            >
                                                Get started
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="mt-8 border-t border-gray-200 pt-6">
                    <blockquote>
                        <div>
                        <p className="text-base text-gray-500">
                            &ldquo;Cras velit quis eros eget rhoncus lacus ultrices sed diam. Sit orci risus aenean curabitur
                            donec aliquet. Mi venenatis in euismod ut.&rdquo;
                        </p>
                        </div>
                        <footer className="mt-3">
                        <div className="flex items-center space-x-3">
                            <div className="flex-shrink-0">
                            <img
                                className="h-6 w-6 rounded-full"
                                src="https://images.unsplash.com/photo-1509783236416-c9ad59bae472?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                                alt=""
                            />
                            </div>
                            <div className="text-base font-medium text-gray-700">Marcia Hill, Digital Marketing Manager</div>
                        </div>
                        </footer>
                    </blockquote>
                    </div> */}
                            </div>
                            <div className="mt-12 sm:mt-16 lg:mt-0 flex items-center ">
                                <div className="pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 img-cont" >
                                    <Image
                                       className='scale-150'
                                        src={`${cloudfront}/static/directory_code_mock.png`}
                                        width={2020}
                                        height={1080}
                                        objectFit={"cover"}
                                        alt="Plaza for video consultations"

                                    />
                                </div>
                            </div>
                        </div>
                    </div>
             

                </section>



                <div className="py-16 bg-slate-200/50 overflow-hidden lg:py-24">
                    <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
                        <svg
                            className="hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4"
                            width={404}
                            height={784}
                            fill="none"
                            viewBox="0 0 404 784"
                            aria-hidden="true"
                        >
                            <defs>
                                <pattern
                                    id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7"
                                    x={0}
                                    y={0}
                                    width={20}
                                    height={20}
                                    patternUnits="userSpaceOnUse"
                                >
                                    <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                                </pattern>
                            </defs>
                            <rect width={404} height={784} fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)" />
                        </svg>

                        <div className="blur-3xl  ml-10  absolute h-32 w-32 -z-10 bg-fuchsia-400" />

                        <div className="relative" id="bookDemo">
                            <h2 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                                Book a demo
                            </h2>


                        </div>
                        <div className="blur-3xl right-0 mr-48 absolute h-32 w-48 -z-10 bg-fuchsia-400" />

                        <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
                            <div className=" sm:mx-auto sm:w-full sm:max-w-3xl">
                                <div className="bg-white   w-full shadow-xl sm:rounded-lg ">
                                    <Calendar
                                        meeting={meeting}
                                        handleChange={handleChange}
                                        handleDateStr={handleDateStr}
                                        handleTimeChange={handleTimeChange}
                                        subPage={subPage}
                                        setSubPage={setSubPage}
                                        setMeeting={setMeeting}
                                        business={true}
                                        activity={null}
                                        slug={"ldew2"}

                                    />
                                </div>
                            </div>
                        </div>





                    </div>
                    <div className=''>

                        <br /> <br /> <br /> <br /> <br /> <br />
                        <p className="text-center">
                            <Link href="/terms-conditions" prefetch={false}>
                                <a > Terms & Conditions | </a>
                            </Link>
                            <Link href="/cookie-policy" prefetch={false}>
                                <a> Cookie Policy | </a>
                            </Link>
                            <Link href="/privacy-policy" prefetch={false} ><a>Privacy Policy</a></Link>
                        </p>
                        {/* <p className="text-center">
    <Link href="/contact" passhref>
        <Button variant="outline-purple" size="sm" className={footerStyles.no_sell_link}>Do Not Sell My Info</Button>
    </Link>
</p> */}
                        <p className="text-center text-gray-400">© 2022 Ordinary Media, LLC. All Rights Reserved.</p>
                    </div>
                </div>


            </main>

            <style jsx global>{`
         .img-cont > span {
          overflow:visible !important;
         }

         body {
            overlfow
         }

        `}</style>
        </div>



    )
}


const alertOptions = {
    // you can also just use 'bottom right'
    position: positions.BOTTOM_RIGHT,
    timeout: 3000,
    offset: '10px',
    containerStyle: { 'zIndex': '9999' },
    // you can also just use 'fade'
    transition: transitions.FADE,
}

Network.getLayout = function getLayout(page) {
    return (
        <AlertProvider template={AlertTemplate} {...alertOptions}>
            <AuthProvider>
                <Layout>
                    {page}
                </Layout>
            </AuthProvider>
        </AlertProvider>
    )
}

